


























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BudgetItem from "@/models/porposal/budgetItem.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from "@/services/user.service";
import { PermissionValue } from "@/enums/PermissionValue";
@Component
export default class BudgetItemTableComponent extends GenericBTable<
  BudgetItem
> {
  created() {
    this.permissionValue = PermissionValue.GASTOPRESUPUESTO;
    this.tableConfig.controller = "BudgetItem";
    this.tableConfig.whereParams = `budgetExpenseId eq 
    ${this.$route.params.budgetExpenseId} `;
    //this.tableConfig.actions.customTemplate = true;
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let index = new BTableColumn("index", "table.index", true);
    this.tableConfig.insertColumns(name,index);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  verOpciones(row: BudgetItem) {
    this.$router.push(
      `/budget-expense/${this.$route.params.budgetExpenseId}/budget-item/${row.id}/budget-sub-item`
    );
  }
}
